import axios from "../lib/axios";

export const createSlogan = async (data) => {
  try {
    const response = await axios.post("/slogan", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create slogan"
    );
  }
};
